import { Component, OnInit, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { ChangelogBellService, ChangelogEntry } from '../../../core/services/changelog-bell.service';

@Component({
  selector: 'app-notification-bell',
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.scss'],
})
export class NotificationBellComponent implements OnInit, OnDestroy {
  unreadCount = 0;
  latestEntries: ChangelogEntry[] = [];
  isDropdownOpen = false;

  private subs: Subscription[] = [];

  constructor(private eRef: ElementRef, private bellService: ChangelogBellService) {}

  ngOnInit(): void {
    this.subs.push(
      this.bellService.unreadCount$.subscribe(count => {
        this.unreadCount = count;
      })
    );

    this.subs.push(
      this.bellService.unreadEntries$.subscribe(entries => {
        // Mostrar solo las últimas 3 entradas no leídas
        this.latestEntries = entries.slice(0, 3);
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  get unreadDisplay(): string {
    return this.unreadCount > 9 ? '9+' : String(this.unreadCount);
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  markAllRead() {
    this.bellService.markAllSeen();
    this.isDropdownOpen = false;
  }

  openChangelog() {
    window.open('/changelog/', '_blank');
    this.isDropdownOpen = false;
  }

  getEntryTag(entry: ChangelogEntry): string {
    if (entry.tags && entry.tags.length > 0) {
      return entry.tags[0];
    }
    const typeMap: Record<string, string> = {
      Nuevo: 'new',
      Mejora: 'improved',
      Fix: 'fix',
      Seguridad: 'security',
      Deprecado: 'deprecation',
      Breaking: 'breaking',
    };
    return typeMap[entry.type] || entry.type || 'new';
  }

  getTagClass(tag: string): string {
    const map: Record<string, string> = {
      new: 'tag-new',
      improved: 'tag-improved',
      fix: 'tag-fix',
      security: 'tag-security',
      deprecation: 'tag-deprecation',
      breaking: 'tag-breaking',
      Nuevo: 'tag-new',
      Mejora: 'tag-improved',
      Fix: 'tag-fix',
      Seguridad: 'tag-security',
      Deprecado: 'tag-deprecation',
      Breaking: 'tag-breaking',
    };
    return map[tag] || 'tag-new';
  }

  getTagLabel(tag: string): string {
    const map: Record<string, string> = {
      new: 'notification_bell.tags.new',
      improved: 'notification_bell.tags.improved',
      fix: 'notification_bell.tags.fix',
      security: 'notification_bell.tags.security',
      deprecation: 'notification_bell.tags.deprecation',
      breaking: 'notification_bell.tags.breaking',
      Nuevo: 'notification_bell.tags.new',
      Mejora: 'notification_bell.tags.improved',
      Fix: 'notification_bell.tags.fix',
      Seguridad: 'notification_bell.tags.security',
      Deprecado: 'notification_bell.tags.deprecation',
      Breaking: 'notification_bell.tags.breaking',
    };
    return map[tag] || tag;
  }



  @HostListener('document:click', ['$event'])
  clickout(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }
}
